export const SUPPORTED_LOCALES = ['en', 'fa', 'ar', 'ru', 'tr', 'fr', 'it', 'de', 'es'];
export const RTL_LOCALES = ['fa', 'ar'];
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
function normalizeLocale(value) {
    return value.toLowerCase().split('-')[0];
}
export function resolveInitialLocale() {
    const saved = localStorage.getItem('projectmanmd-locale');
    if (saved && isSupportedLocale(saved))
        return saved;
    const browserLang = normalizeLocale(navigator.language);
    return isSupportedLocale(browserLang) ? browserLang : 'en';
}
export function applyDocumentLocale(locale) {
    document.documentElement.setAttribute('lang', locale);
    document.documentElement.setAttribute('dir', RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr');
}
export function formatLocaleDate(date, locale) {
    const normalizedDate = typeof date === 'string' ? new Date(date) : date;
    const calendar = locale === 'fa' ? 'persian' : locale === 'ar' ? 'islamic' : 'gregory';
    const region = locale === 'fa' ? 'IR' : locale === 'ar' ? 'SA' : locale.toUpperCase();
    const localeTag = `${locale}-${region}-u-ca-${calendar}`;
    try {
        return new Intl.DateTimeFormat(localeTag, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(normalizedDate);
    }
    catch {
        return normalizedDate.toLocaleDateString();
    }
}
//# sourceMappingURL=locale.js.map